import { render, staticRenderFns } from "./workbench.vue?vue&type=template&id=5a1a51c2&scoped=true&"
import script from "./workbench.vue?vue&type=script&lang=js&"
export * from "./workbench.vue?vue&type=script&lang=js&"
import style0 from "./workbench.vue?vue&type=style&index=0&id=5a1a51c2&lang=scss&scoped=true&"
import style1 from "./workbench.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a51c2",
  null
  
)

export default component.exports